import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Footer from '../../components/footer/Footer';
import { setSelectionRevealState } from '../../store/actions';
import Chat from '../../components/chat/Chat';
import MoreViewsButton from '../../components/moreViewsButton/MoreViewsButton';
import LegalDisclosure from '../../components/legalDisclosure/LegalDisclosure';
import { useThrottledCallback } from 'use-debounce';
import useLargeBreakpoint from '../../hooks/useLargeBreakpoint';
import { useModelInfo } from '../../common/ModelInfoContext';

const BuildView = ({
  options,
  cgi,
  onLoad,
  bottomOffset,
  interiorView = false,
  step,
}) => {
  const { hasTransactionId } = useModelInfo();
  const isAtLeastLarge = useLargeBreakpoint();
  const ref = useRef();

  useEffect(() => {
    onLoad();
  }, []);

  const addTopAndHeight = useThrottledCallback(() => {
    const stepNavHeight = document
      .querySelector('.step-nav__bar')
      ?.getBoundingClientRect().height;

    const bottomNavHeight = document
      .querySelector('.bottom-nav')
      ?.getBoundingClientRect().height;

    if (isAtLeastLarge) {
      ref.current.style.top = stepNavHeight + 'px';
      ref.current.style.height = `calc(100vh - ${stepNavHeight}px - ${bottomNavHeight}px)`;
    } else {
      ref.current.style.top = '';
      ref.current.style.height = '';
    }
  }, 500);

  const analyticsKey = 'right rail';

  useEffect(() => {
    if (isAtLeastLarge && ref?.current) {
      window.addEventListener('resize', addTopAndHeight);
      addTopAndHeight();
    } else {
      window.removeEventListener('resize', addTopAndHeight);
    }

    return () => {
      window.removeEventListener('resize', addTopAndHeight);
    };
  }, [isAtLeastLarge, ref]);

  return (
    <div className="buildview-container">
      <main className="buildview-content-container">
        <div
          className={`buildview-cgi__container${
            interiorView
              ? ' buildview-cgi__container--interior'
              : ' buildview-cgi__container--exterior'
          }`}
          ref={ref}>
          {cgi}
          <LegalDisclosure />
          {interiorView ? (
            <MoreViewsButton
              inverted
              className="more-views-btn--build-view"
              step={step}
            />
          ) : (
            <MoreViewsButton
              className="more-views-btn--build-view"
              step={step}
            />
          )}
        </div>

        <section className="selection-container example-section">
          {options}
          <div className="buildview__footer-section">
            {!hasTransactionId && (
              <section className="cta-container">
                <Chat analyticsKey={analyticsKey} />
              </section>
            )}
            <div
              className="buildview__footer-container"
              style={{ paddingBottom: bottomOffset }}>
              <Footer
                className="buildview__footer"
                analyticsKey={analyticsKey}
              />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

const mapDispatchToProps = {
  onLoad: () => setSelectionRevealState(),
};

export default connect(null, mapDispatchToProps)(BuildView);
